import { render, staticRenderFns } from "./complainList.vue?vue&type=template&id=3403ddca&"
import script from "./complainList.vue?vue&type=script&lang=js&"
export * from "./complainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports